export default __webpack_public_path__ + "static/loader-purple-dfb4b17c80f811b260f3d0a8961b38c6.gif";